import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CreatingCardComponent } from './creating-card.component';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  declarations: [CreatingCardComponent],
  imports: [CommonModule, SharedModule],
  exports: [CreatingCardComponent],
})
export class CreatingCardModule {}
